<template>
<section class="fancy">
	<div class="container">
		<div class="fancy-box">
			<div class="headline-lg">Preorder</div>
			<p>Preorder Project DEIOS now and get full access for all ALPHA and BETA releases.</p>

			<!--
			<div class="row maintenance">
				<div class="box box-xlg maintenance">
					Due to maintenance work, pre-ordering is temporarily not possible!
				</div>
			</div>
			-->
			
			<div class="row">
				<div class="box box-xlg">
					<div class="box-inner">
						<div class="image">
							<img src="~@/assets/img/img_preorder_background.png" alt="Header Background">
							<div class="image-overlay">
								<div class="image">
									<img src="~@/assets/img/img_preorder_standalone.png" alt="">
								</div>
								<div class="headline">
									Standalone application
								</div>
							</div>
						</div>
						<div class="fs-price">
							<span class="fs-price-full" data-fsc-item-path="desktop-application" data-fsc-item-pricetotal data-fsc-smartdisplay></span>
							<span data-fsc-item-path="desktop-application" data-fsc-item-total></span>
							<span class="price-appendix">once</span>
						</div>
						<div class="feature-list">
							<ul>
								<li>
									<div class="title">The application - all yours, forever</div>
									<div class="text-sm">The most powerful map making tool for game masters and worldbuilders. Download and install for <strong>Windows</strong>, <strong>macOS</strong> and <strong>Linux</strong>.</div>
								</li>
								<li>
									<div class="title">One year of updates and support</div>
									<div class="text-sm">Get all updates and improvements for the application for one year after the official release.</div>
								</li>
								<li>
									<div class="title">Over 250 base Fantasy assets</div>
									<div class="text-sm">Design and create your maps with a vast library of base Fantasy assets and base settings.</div>
								</li>
								<li>
									<div class="title">Early access</div>
									<div class="text-sm">Join our ALPHA and BETA releases and help to create project DEIOS with your feedback.</div>
								</li>
							</ul>
						</div>
						<div class="bottom">
							<div class="info-text">
								Still unsure and want more details?<br />
								<a href="#">Learn more</a>
							</div>
							<div class="button-wrapper">
								<a v-on:click="fs('desktop-application')" class="button-sub button-lg">Preorder Now</a>
							</div>
						</div>
					</div>
				</div>
				<div class="box box-xlg">
					<div class="box-inner">
						<div class="image">
							<img src="~@/assets/img/img_preorder_background.png" alt="Header Background">
							<div class="image-overlay">
								<div class="image">
									<img src="~@/assets/img/img_preorder_standalone_with_premium.png" alt="">
								</div>
								<div class="headline">
									Standalone application +<br />
									Premium access for one year
								</div>
							</div>
						</div>
						<div class="fs-price">
							<span class="fs-price-full" data-fsc-item-path="application-1y-premium" data-fsc-item-pricetotal data-fsc-smartdisplay></span>
							<span data-fsc-item-path="application-1y-premium" data-fsc-item-total></span>
							<span class="price-appendix">once</span>
						</div>
						<div class="feature-list">
							<ul>
								<li>
									<div class="title">The application - all yours, forever</div>
									<div class="text-sm">The most powerful map making tool for game masters and worldbuilders. Download and install for <strong>Windows</strong>, <strong>macOS</strong> and <strong>Linux</strong>.</div>
								</li>
								<li>
									<div class="title">One year of updates and support</div>
									<div class="text-sm">Get all updates and improvements for the application for one year after the official release.</div>
								</li>
								<li>
									<div class="title">1 Year premium content subscription</div>
									<div class="text-sm">Design and create your maps with all assets and settings included in our premium content subscription for one year after official launch.</div>
								</li>
								<li>
									<div class="title">Early access</div>
									<div class="text-sm">Join our ALPHA and BETA releases and help to create project DEIOS with your feedback.</div>
								</li>
							</ul>
						</div>
						<div class="bottom">
							<div class="info-text">
								Still unsure and want more details?<br />
								<a href="#">Learn more</a>
							</div>
							<div class="button-wrapper">
								<a v-on:click="fs('application-1y-premium')" class="button-sub button-lg">Preorder Now</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		
		</div>
	</div>
</section>
</template>

<script>
export default {
	name: 'SectionFancyPreorder',
	props: {
		user: Object
	},
	methods: {
		fs(product) {
			// console.log(product);
			window.fastspring.builder.reset();
			window.fastspring.builder.add(product);
			window.fastspring.builder.tag({
				'deiosUserId': this.user.token.sub
			});
			window.fastspring.builder.checkout();
			return false;
		}
	},
}
</script>
